import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Modalable } from "@app/Modalable"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { FinNumberPipe } from "@app/utils/finNumber.pipe"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-external-invoice",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		DateFormatPipe,
		FinNumberPipe,
		CancelBtnComponent,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./external-invoice.component.html",
})
export class ExternalInvoiceComponent {
	@Input() resource: string = ""
	@Input() resourceId: number = 0
	@Input() is_add_assoc: boolean = false
	@Output() onClose = new EventEmitter()

	followups: any[] = []
	followupsLoading: boolean = false
	followupsAllChecked: boolean = false
	fpSum: number = 0
	isFormSubmittable: boolean = false
	invoice_id: string = ""
	isSaving: boolean = false

	constructor(
		public lang: LangService,
		public apiService: ApiService,
		public store: StoreService,
		public modalService: ModalService
	) {}

	ngOnInit() {
		this.reset()
	}
	async reset() {
		this.followups = []
		this.followupsAllChecked = false
		this.invoice_id = ""

		this.followupsLoading = true
		this.followups = await this.apiService.post(
			"get_fps_for_external_invoices",
			{
				fieldName: `${this.resource}_id`,
				resourceId: this.resourceId,
			}
		)
		this.followupsLoading = false
		const meetingtypes = this.store.getSiteDataTable("meetingtypes")
		const patients = this.store.getSiteDataTable("patients")
		this.followups.forEach((followup) => {
			//patient_name,meetingtype_name,date,price,assoc
			if (!followup.price_payor) {
				followup.price_payor = 0
			}
			followup.price =
				this.resource == "payor"
					? followup.price_payor
					: followup.price - followup.price_payor
			if (this.is_add_assoc) {
				followup.assoc = followup.assocIds
					.map((id) => {
						const obj = this.store.searchSiteDataItem(id, ["sub_users"])
						if (!obj) {
							return ""
						}
						return `${obj.name} ${obj.license_number ? this.lang.getVal("mr") + " " + obj.license_number : ""}`
						//return `${obj.name} (${obj.license_number})`;
					})
					.join(", ")
			}
			const meetingtype = meetingtypes.find(
				(it) => it.id == followup.meetingtype_id
			)
			const patient = patients.find((it) => it.id == followup.patient_id)
			followup.meetingtype_name = meetingtype?.name || ""
			if (followup.meetingtype_id == -1) {
				followup.meetingtype_name = this.lang.getVal("former_debt")
			}
			followup.patient_name = patient?.name || ""
		})
		this.followups.sort(
			(a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
		)
		this.checkAll(true)
	}
	checkAll(doCheck: boolean) {
		this.followupsAllChecked = doCheck
		this.followups.forEach((followup) => (followup.checked = doCheck))
		this.calcFollowupsSum()
		this.validateEntireForm()
	}
	followupCheck(followup: any, checked: boolean) {
		followup.checked = checked
		this.calcFollowupsSum()
		this.validateEntireForm()
	}
	checkedFps() {
		return this.followups.filter(({ checked }) => checked)
	}
	calcFollowupsSum() {
		this.fpSum = this.store.only2Digits(
			this.checkedFps().reduce((acc, { price }) => acc + price, 0)
		)
	}
	validateEntireForm() {
		this.isFormSubmittable = !!this.invoice_id && !!this.checkedFps().length
	}
	async save() {
		this.isSaving = true
		const checkedItems = this.checkedFps()
		const attend_ids = checkedItems
			.filter((it) => it.attend_id)
			.map((it) => it.attend_id)
		const fp_ids = checkedItems.filter((it) => !it.attend_id).map((it) => it.id)

		await this.apiService.post("save_external_id", {
			fieldName: `${this.resource}_id`,
			attend_ids,
			fp_ids,
			invoice_id: this.invoice_id,
		})
		this.modalService.openToast("followups_were_updated")
		this.isSaving = false
		this.onClose.emit(true)
	}
}
